import { Input } from '@bancobarigui/barihaus';

interface EditableTitleProps {
  value: string;
  onChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
  size?: 'small' | 'middle' | 'large';
  placeholder?: string;
}

export function EditableTitle({
  value,
  onChange,
  onSave,
  onCancel,
  size = 'middle',
  placeholder = 'Digite o nome',
}: EditableTitleProps) {
  const handleBlur = () => {
    if (value.trim() === '') {
      onCancel();
    } else {
      onSave();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      onSave();
    } else if (e.key === 'Escape') {
      onCancel();
    }
  };

  return (
    <Input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      autoFocus
      size={size}
      className="flex-1"
      placeholder={placeholder}
    />
  );
}
